import { LogInRequired } from "@/app-shell/layouts/LogInRequired"
import { Skeleton } from "@coval/ui"

export function DashboardLoadingState() {
  return (
    <LogInRequired>
      <div
        className="flex min-h-0 min-w-0 flex-1 flex-col"
        role="status"
        aria-label="Loading dashboard"
      >
        <div className="z-10 min-w-0 shrink-0">
          <div className="flex min-w-0 items-center gap-2 px-6 pb-4">
            <Skeleton className="h-8 w-56 rounded-md" />
            <Skeleton className="h-8 w-8 rounded-md" />
          </div>
        </div>

        <div className="min-h-0 min-w-0 flex-1 bg-surface-contrast" />
      </div>
    </LogInRequired>
  )
}
